import AxiosInstance from 'src/shared/services/axios/interceptor';
import { PagedResult } from 'src/shared/models/pagedResult';
import { InvoiceMissionOptions } from '../models/options/invoiceMissionOptions';
import { InvoiceMissionResponse } from '../models/invoiceMission/invoiceMission';
import { InvoiceSendingTypeStringEnum } from '../models/enums/InvoiceSendingTypeString.enum';

const controller = 'InvoiceMission';

const getAll = (opts: InvoiceMissionOptions) => {
  return AxiosInstance.get<PagedResult<InvoiceMissionResponse>>(`${controller}`, {
    params: opts,
  });
};

const getById = (id: string | number, sendingType?: number, includeSendingApprovalEmails?: boolean) => {
  let endpoint = sendingType !== undefined && sendingType > 0 ? `${controller}/${id}/${sendingType}` : `${controller}/${id}`;
  endpoint += includeSendingApprovalEmails ? `?includeSendingApprovalEmails=${includeSendingApprovalEmails}` : '';
  return AxiosInstance.get<InvoiceMissionResponse>(endpoint);
};

const deleteInvoiceMission = (id: number) => {
  const endpoint = `${controller}/${id}`;
  return AxiosInstance.delete(endpoint);
};

export const acceptInvoiceMission = (invoiceMissionId: number, sendingType: InvoiceSendingTypeStringEnum | null) => {
  const endpoint = `${controller}/${invoiceMissionId}/Accept/${sendingType}`;
  return AxiosInstance.put(endpoint);
};

export const rejectInvoiceMission = (invoiceMissionId: number, sendingType: InvoiceSendingTypeStringEnum | null, message: string) => {
  const endpoint = `${controller}/${invoiceMissionId}/Reject/${sendingType}`;
  return AxiosInstance.put(endpoint, { message });
};

export default {
  getAll,
  getById,
  deleteInvoiceMission,
};
